export default __webpack_public_path__ + "static/mobileBanner4-d626bd3be55b0f3998e7a42f0a2420bd.png";